import { 
    Component,
     OnInit,
     Input,
     OnChanges,
     SimpleChange,
     ChangeDetectionStrategy
} from '@angular/core';
    
import { ActivatedRoute,
     Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';

@Component({
  selector: 'search-section',
  templateUrl: './search-section.template.html',
  styleUrls: ['./search-section.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SearchSection {
    @Input() row : any;
    //@Input() rowObservable : Observable<any>
    constructor(
      private coreEffects : CoreEffects,
      private route: ActivatedRoute
    ){};
  
    ngOnInit(){
        
        
        //this.row = Observable.of(this.row);
        //this.rowObservable = Observable.of(this.row);
        //this.coreEffects.getAsyncChildDataAsObservable(this.row, this.route.snapshot.params, true);
    }

    ngOnChanges(changes){ 
    }
}




// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/search/search-section/search-section.component.ts